<div (scroll)="onScrollEvent($event)" class="p-relative" fxLayout="row wrap">
    <div *ngIf="detailData" fxFlex="100">
        <app-bread-crumbs
            [lang]="lang"
            [routes]="breadCrumbsRoutes"
            [productName]="
                lang == 'en' ? detailData?.name_en : detailData?.name_ar
            "
        >
        </app-bread-crumbs>
    </div>
    <div class="h-100 w-100">
        <div
            *ngIf="detailData"
            class="product-detail-page section-gap"
            [ngClass]="{'bg-grey': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI}"
        >
            <div class="details-bar" [ngClass]="{ 'd-none': !showDetailBar }">
                <div class="container mt-md-4">
                    <div
                        class="mt-1 mb-1 details"
                        fxLayout="row wrap"
                        fxLayoutAlign="space-between center"
                        fxLayout.xs="100"
                    >
                        <div
                            fxLayout="row wrap"
                            fxLayoutAlign="space-between center"
                            fxLayout.xs="100"
                        >
                            <div class="img-preview" fxLayout.sm="100px">
                                <img
                                    [src]="
                                        detailData?.images?.length
                                            ? detailData?.images[0].url
                                            : detailData?.image
                                    "
                                    [alt]="detailData?.name"
                                    default="./assets/images/placeholder70.png"
                                    onError="this.src='./assets/images/placeholder70.png';"
                                />
                            </div>

                            <div
                                class="productDetailsContent justify-center align-center px-2"
                                fxLayout.sm=""
                            >
                                <div class="text-bold ellipsis-text fs-sm-12">
                                    {{ detailData?.name }}
                                </div>

                                <div class="text-bold">
                                    <span
                                        fxLayout="row wrap"
                                        *ngIf="detailData?.in_stock"
                                    >
                                        <!-- main price -->
                                        <span
                                            *ngIf="
                                                detailData?.discount_price &&
                                                detailData?.stock > 0 &&
                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                            "
                                            [ngClass]="
                                                detailData?.discount_price
                                                    ? 'new-price'
                                                    : ''
                                            "
                                            class="accent-color price d-flex align-items-center fs-sm-12"
                                        >
                                            {{
                                                detailData?.discount_price
                                                    | number
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                            &nbsp;
                                        </span>

                                        <!-- old price -->
                                        <span
                                            *ngIf="
                                                detailData?.price &&
                                                detailData?.stock > 0 &&
                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                            "
                                            [ngClass]="
                                                detailData?.discount_price
                                                    ? 'old-price'
                                                    : 'price-orginal'
                                            "
                                            class="accent-color fs-sm-12"
                                        >
                                            {{
                                                detailData?.price
                                                    | number
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                        </span>
                                    </span>

                                    <span
                                        class="text-sm text-muted fs-sm-12"
                                        *ngIf="
                                            !environmentVariables?.NEW_PRODUCTS_DETAILS_UI &&
                                            product_variant?.sku &&
                                            !detailData?.available_soon &&
                                            (environmentVariables?.SHOW_SKU_PRODUCT_DETAILS === true ||
                                            environmentVariables?.SHOW_SKU_PRODUCT_DETAILS === null)
                                        "
                                    >
                                        <span class="fs-sm-12"
                                            >{{
                                                "receipt.sku" | translate
                                            }}:</span
                                        >
                                        <span class="fs-sm-12" dir="ltr">
                                            {{ product_variant?.sku }}
                                        </span>
                                    </span>

                                    <span
                                        class="mx-2 text-sm text-muted"
                                        *ngIf="
                                            product_variant?.barcode &&
                                            environmentVariables?.SHOW_BARCODE_PRODUCT_DETAILS ===
                                                true
                                        "
                                    >
                                        {{ "receipt.barcode" | translate }}:
                                        <span dir="ltr">
                                            {{ product_variant?.barcode }}
                                        </span>
                                    </span>

                                    <span
                                        *ngIf="detailData?.preorder"
                                        class="mx-2 text-sm"
                                    >
                                        {{
                                            "productDetails.preorder"
                                                | translate
                                        }}
                                    </span>

                                    <span
                                        *ngIf="
                                            (!detailData?.in_stock ||
                                                detailData.stock == 0) &&
                                            !detailData?.available_soon &&
                                            detailData.stock != null
                                        "
                                        class="mx-2 text-sm primary-text"
                                    >
                                        {{ "orders.outOfStock" | translate }}
                                    </span>

                                    <span
                                        *ngIf="detailData?.available_soon"
                                        class="mx-2 text-sm primary-text"
                                    >
                                        {{
                                            "productDetails.availableSoon"
                                                | translate
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- view in mobile & scrollable bar -->
                        <div fxLayout.sm="auto" class="container-buttons-bar">
                            <div class="mb-1">
                                <div
                                    class="stock-values"
                                    [ngClass]="{
                                        'add-px8':
                                            environmentVariables?.ADD_TO_CART_TEXT_EN ==
                                            '‎ +‎ ‎'
                                    }"
                                >
                                    <app-control-add-to-cart
                                        [source]="'details-bar'"
                                        *ngIf="product_variant"
                                        [product]="product_variant"
                                        [styleCard]="true"
                                        [styleDetails]="true"
                                        [redirectToProduct]="false"
                                    >
                                    </app-control-add-to-cart>
                                </div>
                            </div>
                            <div
                                class="row space-between center"
                                class="text-muted"
                            >
                                <button
                                    *ngIf="
                                        environmentVariables?.ENABLE_SHOW_BUY_NOW_BUTTON &&
                                        environmentVariables?.GUEST_CAN_VIEW_PRICES &&
                                        product_variant?.in_stock &&
                                        !product_variant?.available_soon
                                    "
                                    mat-raised-button
                                    (click)="addToCart()"
                                    class="buy-now-btn no-shadow h-sm-24px"
                                    [ngClass]="{
                                        'w-150px px-2': environmentVariables?.ADD_TO_CART_TEXT_EN != '‎ +‎ ‎',
                                        'w-100 d-flex align-items-center justify-center': 
                                            environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'
                                    }"
                                >
                                    <mat-icon 
                                        class="material-icons material-symbols-outlined mr-1 d-md-inline-block d-none" 
                                        *ngIf="environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'"
                                        aria-hidden="false">
                                        shopping_cart
                                    </mat-icon>
                                    <span class="text-capitalize fs-sm-12">{{ "cart.Buy_NOW" | translate }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="button-lg-parent my-2 d-none"
                        fxLayout.lg="30"
                        fxLayout.md="30"
                        fxLayout.sm="100"
                        fxLayout.xl="30"
                        fxLayout.xs="100"
                        fxLayoutAlign="center center"
                    >
                        <!--Regular Product-->
                        <div class="stock-values">
                            <app-control-add-to-cart
                                [source]="'details'"
                                *ngIf="product_variant"
                                [product]="product_variant"
                                [styleCard]="true"
                                [styleDetails]="true"
                                [redirectToProduct]="false"
                            >
                            </app-control-add-to-cart>

                            <p
                                *ngIf="
                                    environmentVariables?.SHOW_ITEMS_LEFT_LABEL &&
                                    product_variant?.stock -
                                        product_variant?.amount <
                                        5 &&
                                    product_variant?.stock -
                                        product_variant?.amount >
                                        0
                                "
                                class="mx-2 ma mt-0"
                            >
                                {{ "only" | translate }}
                                {{ product_variant.stock - product_variant.amount
                                }}
                                {{ "left_in_stock" | translate }}
                            </p>
                        </div>
                        <div class="share-area share-web-view">
                            <div class="divider"></div>

                            <div
                                class="row space-between center"
                                class="text-muted py-2"
                            >
                                <button
                                    *ngIf="
                                        environmentVariables?.ENABLE_SHOW_BUY_NOW_BUTTON &&
                                        environmentVariables?.GUEST_CAN_VIEW_PRICES &&
                                        product_variant?.in_stock &&
                                        !product_variant?.available_soon
                                    "
                                    mat-raised-button
                                    (click)="addToCart()"
                                    [ngClass]="{
                                        'w-150px px-2': environmentVariables?.ADD_TO_CART_TEXT_EN != '‎ +‎ ‎',
                                        'h-40px': environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'
                                    }"
                                    class="buy-now-btn no-shadow text-capitalize"
                                >
                                    {{ "cart.Buy_NOW" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div
                    class="col-gap"
                    fxLayout="row wrap"
                    fxLayoutAlign="center center"
                >
                    <div
                        fxFlex.lg="100"
                        fxFlex.md="100"
                        fxFlex.sm="100"
                        fxFlex.xl="100"
                        fxFlex.xs="100"
                    >
                        <div
                            class="col-gap position-relative"
                            fxLayout="row wrap"
                        >
                            <div
                                fxFlex.lg="50"
                                fxFlex.md="40"
                                fxFlex.sm="100"
                                fxFlex.xl="40"
                                fxFlex.xs="100"
                                style="max-width: 100% !important"
                            >
                                <div fxLayout="row wrap">
                                    <div
                                        *ngIf="mainImgPath"
                                        class="relative border-main-image zoom"
                                        fxFlex.lg="100"
                                        fxFlex.md="100"
                                        fxFlex.sm="100"
                                        fxFlex.xl="100"
                                        fxFlex.xs="100"
                                    >
                                        <embryo-ImgZoom
                                            [productName]="
                                                lang == 'en'
                                                    ? detailData?.name_en
                                                    : detailData?.name_ar
                                            "
                                            [imgSrc]="mainImgPath"
                                            [images]="detailData?.images"
                                            [videoUrl]="detailData?.video"
                                            [videoThumbUrl]="
                                                youtubeTrustedThumbnailUrl
                                            "
                                            [product_variant]="product_variant"
                                            [environmentVariables]="environmentVariables"
                                            [detailData]="detailData"
                                        >
                                        </embryo-ImgZoom>

                                        <div
                                            class="chip-container pointer-event-none d-flex flex-column"
                                            [class.chip-ar]="lang == 'ar'"
                                        >
                                            <mat-chip
                                                *ngIf="
                                                    detailData?.discount_price !==
                                                        null &&
                                                    detailData?.price &&
                                                    !detailData?.promotion &&
                                                    detailData?.stock > 0
                                                "
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{
                                                    ((detailData?.price -
                                                        detailData?.discount_price) /
                                                        detailData?.price) *
                                                        100 | number : "1.0-0"
                                                }}
                                                %
                                                <span
                                                    *ngIf="
                                                        environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL
                                                    "
                                                >
                                                    {{
                                                        "productDetails.off"
                                                            | translate
                                                    }}
                                                </span>
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    detailData?.discount_price !==
                                                        null &&
                                                    detailData?.promotion
                                                "
                                                class="chip-item my-1 pointer-event-none"
                                                tabindex="-1"
                                            >
                                                <ng-container
                                                    *ngIf="lang == 'en'"
                                                >
                                                    {{
                                                        detailData?.promotion_en
                                                    }}
                                                    OR
                                                    {{
                                                        ((detailData?.price -
                                                            detailData?.discount_price) /
                                                            detailData?.price) *
                                                            100
                                                            | number : "1.0-0"
                                                    }}
                                                    %
                                                    <span
                                                        *ngIf="
                                                            environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL
                                                        "
                                                    >
                                                        OFF
                                                    </span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="lang == 'ar'"
                                                >
                                                    {{
                                                        detailData?.promotion_ar
                                                    }}
                                                    أو خصم
                                                    {{
                                                        ((detailData?.price -
                                                            detailData?.discount_price) /
                                                            detailData?.price) *
                                                            100
                                                            | number : "1.2-2"
                                                    }}
                                                    %
                                                </ng-container>
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    product_variant?.preorder
                                                "
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{
                                                    "productDetails.preorder"
                                                        | translate
                                                }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    product_variant?.available_soon
                                                "
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{
                                                    "productDetails.availableSoon"
                                                        | translate
                                                }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    detailData?.promos
                                                        ?.length &&
                                                    detailData?.promos[0]
                                                        ?.show_in_product != 0
                                                "
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{
                                                    detailData?.promos[0]?.name
                                                }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    detailData?.promotion &&
                                                    !detailData?.direct_discount
                                                "
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{ detailData?.promotion }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    product_variant?.promotion &&
                                                    !product_variant?.direct_discount &&
                                                    !detailData?.promotion
                                                "
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{ product_variant?.promotion }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="detailData?.type === 2"
                                                class="chip-item pointer-event-none my-1"
                                                tabindex="-1"
                                            >
                                                {{
                                                    "productDetails.bundle"
                                                        | translate
                                                }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    detailData.commission_amount &&
                                                    user?.is_affiliate &&
                                                    detailData.commission_amount !=
                                                        0
                                                "
                                                class="chip-item chip-commission-amount my-1"
                                                tabindex="-1"
                                            >
                                                {{
                                                    "orders.commission"
                                                        | translate
                                                }}
                                                :
                                                {{
                                                    detailData.commission_amount
                                                        | number : "1.2-2"
                                                }}
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                }}
                                            </mat-chip>

                                            <mat-chip
                                                *ngIf="
                                                    !product_variant?.in_stock
                                                "
                                                class="chip-item pointer-event-none"
                                                tabindex="-1"
                                            >
                                                {{
                                                    "home_Page.outOfStouck"
                                                        | translate
                                                }}
                                            </mat-chip>
                                        </div>
                                        <div
                                            class="img-brand"
                                            *ngIf="
                                                detailData?.details?.brand
                                                    ?.image &&
                                                environmentVariables?.SHOW_BRAND_ON_PRODUCT
                                            "
                                        >
                                            <img
                                                [alt]="
                                                    detailData?.details?.brand
                                                        ?.image
                                                "
                                                [src]="
                                                    detailData?.details?.brand
                                                        ?.image
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                fxLayout="column"
                                fxFlex.lg="50"
                                fxFlex.md="60"
                                fxFlex.sm="100"
                                fxFlex.xl="60"
                                fxFlex.xs="100"
                            >
                                <div class="product-detail-content">
                                    <span
                                        class="accent-color promos-description"
                                        *ngIf="
                                            detailData?.promos?.length &&
                                            detailData?.promos[0]
                                                ?.show_in_product != 0
                                        "
                                    >
                                        {{ detailData?.promos[0].description }}
                                    </span>

                                    <!-- brand -->
                                    <div
                                        *ngIf="
                                            environmentVariables?.NEW_PRODUCTS_DETAILS_UI &&
                                            detailData?.details?.brand?.name
                                        "
                                        class="mb-3"
                                    >
                                        <span class="font-medium">
                                            {{
                                                "productDetails.brand"
                                                    | translate
                                            }}</span
                                        > :
                                        <span
                                            [queryParams]="{
                                                brand_id:
                                                    detailData?.details?.brand?.id
                                            }"
                                            [routerLink]="['/' + lang + '/products']"
                                            class="text-blue pointer fw-600"
                                        >
                                            {{
                                                lang == "en"
                                                    ? detailData?.details
                                                            ?.brand?.name
                                                    : detailData?.details
                                                            ?.brand?.name_ar
                                            }}
                                        </span>
                                    </div>

                                    <!-- product name -->
                                    <h1 class="product-name">
                                        {{ detailData?.name }}
                                    </h1>

                                    <!-- Price -->
                                    <div
                                        *ngIf="detailData?.in_stock && detailData?.stock > 0"
                                        class="product-detail-price mt-3"
                                    >
                                        <h4
                                            *ngIf="
                                                detailData?.discount_price &&
                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                            "
                                            [ngClass]="{
                                                'config-price-before-discount':
                                                    detailData?.discount_price &&
                                                    environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                'fs-28': environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                            }"
                                            class="defult-price-color payment-with-discount-container d-flex price"
                                        >
                                            {{
                                                detailData?.discount_price
                                                    | number : "1.0"
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                        </h4>
                                        <br class="d-md-none d-block" 
                                             *ngIf="detailData?.discount_price" />

                                        <!-- Discount Price -->
                                        <span>
                                            <span
                                                *ngIf="
                                                    detailData?.price &&
                                                    detailData?.stock > 0 &&
                                                    environmentVariables?.GUEST_CAN_VIEW_PRICES
                                                "
                                                [ngClass]="{
                                                    'config-price-after-discount':
                                                        detailData?.discount_price &&
                                                        environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                    'config-price-color':
                                                        environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                    'defult-price-color-after-discount':
                                                        !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                        detailData?.discount_price,
                                                    'fs-20':
                                                        detailData?.discount_price && 
                                                        environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                    'fs-28':
                                                        !detailData?.discount_price && 
                                                        environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                                }"
                                                class="defult-price-color"
                                            >
                                                {{
                                                    detailData?.price
                                                        | number : "1.0"
                                                }}
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                }}
                                            </span>
                                        </span>

                                        <!-- save price difference -->
                                        <span 
                                            *ngIf="
                                                detailData?.discount_price && 
                                                detailData?.price &&
                                                environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                            "
                                            class="ml-2 bg-red text-white rounded-pill px-2 py-1 text-product-price-color-before-discount"
                                        >
                                            <span
                                                class="text-capitalize"
                                                *ngIf="
                                                    environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL
                                                "
                                            >{{ "productDetails.save" | translate }}
                                            </span>
                                            {{
                                                (detailData?.price -
                                                    detailData?.discount_price)
                                                | number : "1.0-0"
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                        </span>

                                        <span
                                            *ngIf="
                                                detailData?.price &&
                                                environmentVariables?.ENABLE_INCLUDING_VAT
                                            "
                                            class="inc-vat"
                                        >
                                            {{ "IncVAT" | translate }}
                                        </span>
                                    </div>

                                    <div
                                        *ngIf="
                                            detailData?.price &&
                                            detailData?.stock == 0 &&
                                            environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE &&
                                            environmentVariables?.GUEST_CAN_VIEW_PRICES
                                        "
                                        class="d-flex"
                                    >
                                           <h4
                                            *ngIf="
                                                detailData?.discount_price &&
                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                            "
                                            [ngClass]="{
                                                'config-price-before-discount':
                                                    detailData?.discount_price &&
                                                    environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                'fs-28': environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                            }"
                                            class="defult-price-color payment-with-discount-container d-flex price"
                                        >
                                            {{
                                                detailData?.discount_price
                                                    | number : "1.0"
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                        </h4>

                                        <!-- Discount Price -->
                                        <span>
                                            <span
                                                *ngIf="
                                         
                                                    environmentVariables?.GUEST_CAN_VIEW_PRICES
                                                "
                                                [ngClass]="{
                                                    'config-price-after-discount':
                                                        detailData?.discount_price &&
                                                        environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                    'config-price-color':
                                                        environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                    'defult-price-color-after-discount':
                                                        !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                        detailData?.discount_price,
                                                    'fs-20':
                                                        detailData?.discount_price && 
                                                        environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                    'fs-28':
                                                        !detailData?.discount_price && 
                                                        environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                                }"
                                                class="defult-price-color"
                                            >
                                                {{
                                                    detailData?.price
                                                        | number : "1.0"
                                                }}
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                }}
                                            </span>
                                        </span>

                                        <!-- save price difference -->
                                        <span 
                                            *ngIf="
                                                detailData?.discount_price && 
                                                detailData?.price &&
                                                environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                            "
                                            class="ml-2 bg-red text-white rounded-pill px-2 py-1 text-product-price-color-before-discount"
                                        >
                                            <span
                                                class="text-capitalize"
                                                *ngIf="
                                                    environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL
                                                "
                                            >{{ "productDetails.save" | translate }}
                                            </span>
                                            {{
                                                (detailData?.price -
                                                    detailData?.discount_price)
                                                | number : "1.0-0"
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                        </span>

                                        <span
                                            *ngIf="
                                                detailData?.price &&
                                                environmentVariables?.ENABLE_INCLUDING_VAT
                                            "
                                            class="inc-vat"
                                        >
                                            {{ "IncVAT" | translate }}
                                        </span>
                                    </div>
  
                                    <!-- Selected Installment Plan -->
                                    <div *ngIf="
                                            selectedPlan && 
                                            detailData &&
                                            environmentVariables?.ENABLE_BANK_INSTALLMENTS_PRODUCT_UI
                                        "
                                        class="mt-3"
                                    >
                                        <span class="d-inline-flex justify-center align-items-center">
                                            <span class="text-brand fs-14 mr-1">
                                                {{  
                                                    detailData.discount_price ?
                                                        (detailData.discount_price / selectedPlan.months).toFixed(1) : 
                                                        (detailData.price / selectedPlan.months).toFixed(1)
                                                }}
                                            </span>
                                            <span class="fs-14 mr-1">
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                }} 
                                                {{'productDetails.monthly' | translate}}
                                                /
                                                {{ selectedPlan.months }} 
                                                {{ selectedPlan.months > 11 ? 
                                                    ('productDetails.months' | translate) :
                                                    ('productDetails.month' | translate)
                                                }}
                                            </span>
                                            <a class="fs-12 text-decoration-underline text-brand"
                                                (click)="navigateToPlanSection('#selected-installment-plan-info', true)" href="javascript:void(0)">
                                                {{ 'productDetails.clickHereForMorePlans' | translate }}
                                            </a>
                                        </span>
                                    </div>
                                         
                                    <!-- payment method discount -->
                                    <div
                                        class="border-hashed-blue text-capitalize bg-light-blue text-blue p-2 my-3 rounded-lg"
                                        *ngIf="
                                            detailData?.in_stock && 
                                            product_variant?.payment_methods_discount_name_en
                                        "
                                    >
                                        {{
                                            lang == "en"
                                                ? product_variant?.payment_methods_discount_name_en
                                                : product_variant?.payment_methods_discount_name_ar
                                        }}
                                    </div>

                                    <ul class="no-style mb-3">
                                        <li *ngIf="!environmentVariables?.NEW_PRODUCTS_DETAILS_UI">
                                            <span class="font-medium">
                                                {{
                                                    "productDetails.availablity" | translate
                                                }}
                                            </span>:
                                            <span
                                                *ngIf="
                                                    product_variant?.in_stock &&
                                                    !product_variant?.available_soon &&
                                                    !product_variant?.preorder
                                                "
                                            >
                                                {{
                                                    "productDetails.inStocks"
                                                        | translate
                                                }}
                                                &nbsp;
                                            </span>
                                            <span
                                                *ngIf="
                                                    !product_variant?.in_stock
                                                "
                                                class="color-brand"
                                            >
                                                {{
                                                    "home_Page.outOfStouck"
                                                        | translate
                                                }}
                                                &nbsp;
                                            </span>
                                            <span
                                                *ngIf="
                                                    product_variant?.available_soon
                                                "
                                            >
                                                {{
                                                    "productDetails.availableSoon"
                                                        | translate
                                                }}
                                                &nbsp;
                                            </span>
                                            <span
                                                *ngIf="
                                                    product_variant?.preorder
                                                "
                                            >
                                                {{
                                                    "productDetails.preorder"
                                                        | translate
                                                }}
                                            </span>
                                        </li>

                                        <!-- in Stocks -->
                                        <!-- out Of Stouck -->
                                        <!-- <li *ngIf="environmentVariables?.NEW_PRODUCTS_DETAILS_UI">
                                            <span
                                                class="bg-light-green text-green rounded-md py-1 px-2 text-uppercase fs-12 fw-bold"
                                                *ngIf="
                                                    product_variant?.in_stock &&
                                                    !product_variant?.available_soon &&
                                                    !product_variant?.preorder
                                                "
                                            >
                                                <span class="stock-dot bg-green mr-1"></span>
                                                {{
                                                    "productDetails.inStocks" | translate
                                                }}
                                            </span>

                                            <span
                                                *ngIf="
                                                    !product_variant?.in_stock
                                                "
                                                class="bg-light-red text-red rounded-md py-1 px-2 text-capitalize fs-12 fw-bold"
                                            >
                                                <span class="stock-dot bg-red mr-1"></span>
                                                {{
                                                    "home_Page.outOfStouck" | translate
                                                }}
                                            </span>

                                            <span
                                                *ngIf="
                                                    product_variant?.available_soon
                                                "
                                            >
                                                {{
                                                    "productDetails.availableSoon"
                                                        | translate
                                                }}
                                                &nbsp;
                                            </span>
                                            <span
                                                *ngIf="
                                                    product_variant?.preorder
                                                "
                                            >
                                                {{
                                                    "productDetails.preorder"
                                                        | translate
                                                }}
                                            </span>
                                        </li> -->

                                        <li 
                                            *ngIf="
                                                product_variant?.sku &&
                                                !detailData?.available_soon &&
                                                (environmentVariables?.SHOW_SKU_PRODUCT_DETAILS ===
                                                    true ||
                                                    environmentVariables?.SHOW_SKU_PRODUCT_DETAILS ===
                                                        null)
                                            "
                                        >
                                            <span class="font-medium">

                                                {{
                                                    "receipt.sku" | translate
                                                }}</span
                                            > :
                                            <span [dir]="'ltr'">
                                                {{ product_variant?.sku }}</span
                                            >
                                        </li>
                                        <li
                                            *ngIf="
                                                product_variant?.barcode &&
                                                environmentVariables?.SHOW_BARCODE_PRODUCT_DETAILS ===
                                                    true
                                            "
                                        >
                                            <span class="font-medium">{{
                                                "receipt.barcode" | translate
                                            }}</span
                                            >:
                                            <span [dir]="'ltr'">{{
                                                product_variant?.barcode
                                            }}</span>
                                        </li>

                                        <!-- brand -->
                                        <li
                                            *ngIf="
                                                detailData?.details?.brand?.name &&
                                                !environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                            "
                                        >
                                            <span class="font-medium">
                                                {{
                                                    "productDetails.brand"
                                                        | translate
                                                }}</span
                                            >:
                                            <span
                                                [queryParams]="{
                                                    brand_id:
                                                        detailData?.details
                                                            ?.brand?.id
                                                }"
                                                [routerLink]="[
                                                    '/' + lang + '/products'
                                                ]"
                                                class="brand-name"
                                                style="outline: none"
                                            >
                                                {{
                                                    lang == "en"
                                                        ? detailData?.details
                                                              ?.brand?.name
                                                        : detailData?.details
                                                              ?.brand?.name_ar
                                                }}
                                            </span>
                                        </li>

                                        <!-- Top Service Features -->
                                        <li fxLayout="row wrap" class="flex-gap-mobile"  *ngIf="product_variant?.details_services?.length">
                                            <div class="p-1 service-card-width" *ngFor="let item of product_variant.details_services">
                                                <div class="bg-header-search label-text-color p-2 rounded-lg h-100">
                                                    <div class="d-flex align-items-start">
                                                        <div class="pr-1 d-flex align-items-start">
                                                            <img
                                                                *ngIf="item.image_en"
                                                                class="d-inline-block object-fit-contain w-18px"
                                                                [src]="lang === 'ar' ? item.image_ar : item.image_en"
                                                                width="18"
                                                                height="18"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                        <div fxLayout="column">
                                                            <!-- feature title -->
                                                            <div class="fs-12 fw-bold feature-title" *ngIf="item.title_en">
                                                                {{ lang == 'ar'? item.title_ar : item.title_en }}
                                                            </div>
                                                            <!-- feature description -->
                                                            <div class="fs-12 feature-description" *ngIf="item.description_en">
                                                                {{ lang == 'ar'? item.description_ar : item.description_en }}
                                                            </div>
                                                            <!-- feature link -->
                                                            <a class="fs-10 text-blue" *ngIf="item.link_en" 
                                                                [href]="lang == 'ar'? item.link_ar : item.link_en" target="_blank">
                                                                {{ 'button.moreInfoHere' | translate }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li>
                                            <div class="mb-3 select-group">
                                                <div
                                                    class="w-100 border-bottom my-1"
                                                ></div>

                                                <div
                                                    *ngFor="
                                                        let product_variants_option of detailData?.product_variants_options;
                                                        let i = index
                                                    "
                                                    class="option-product-variant"
                                                >
                                                    <div
                                                        *ngIf="
                                                            product_variants_option
                                                                .option.type ==
                                                                1 &&
                                                            product_variants_option
                                                                ?.option
                                                                ?.preview_type ==
                                                                1
                                                        "
                                                    >
                                                        <h6 class="name-option">
                                                            {{ 
                                                                lang == 'ar'? 
                                                                    product_variants_option.option.name_ar : product_variants_option.option.name
                                                            }}
                                                        </h6>

                                                        <span
                                                            *ngFor="
                                                                let value of product_variants_option.values
                                                            "
                                                            class="container-option-variant"
                                                        >
                                                            <span
                                                                (click)="
                                                                    selectVariant(
                                                                        product_variants_option.option,
                                                                        value,
                                                                        product_variant.id
                                                                    )
                                                                "
                                                                [ngClass]="{
                                                                    'rounded-lg border-gray': environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                                    'option-text-border': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                                    'active-option-select':
                                                                        value.state ==
                                                                        1
                                                                }"
                                                                class="option-img-varants option-text"
                                                            >
                                                                {{
                                                                    value.name ||
                                                                        "-"
                                                                }}
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <div
                                                        *ngIf="
                                                            product_variants_option
                                                                .option.type ==
                                                                1 &&
                                                            product_variants_option
                                                                ?.option
                                                                ?.preview_type ==
                                                                2
                                                        "
                                                    >
                                                        <mat-form-field
                                                            class="mb-3"
                                                        >
                                                            <mat-label>{{
                                                                product_variants_option
                                                                    ?.option
                                                                    .name
                                                            }}</mat-label>
                                                            <mat-select
                                                                [(ngModel)]="
                                                                    option2Selected
                                                                "
                                                                (selectionChange)="
                                                                    selectVariantFromDrobdown(
                                                                        product_variants_option?.option,
                                                                        $event,
                                                                        product_variants_option?.values,
                                                                        product_variant?.id
                                                                    )
                                                                "
                                                            >
                                                                <mat-option
                                                                    [value]="
                                                                        value.id
                                                                    "
                                                                    *ngFor="
                                                                        let value of product_variants_option?.values
                                                                    "
                                                                >
                                                                    {{
                                                                        value?.name
                                                                    }}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>

                                                    <div
                                                        *ngIf="
                                                            product_variants_option
                                                                .option.type ==
                                                            3
                                                        "
                                                    >
                                                        <h6 class="name-option">
                                                            {{ 
                                                                lang == 'ar'? 
                                                                    product_variants_option.option.name_ar : product_variants_option.option.name
                                                            }}
                                                        </h6>
                                                        <span
                                                            *ngFor="
                                                                let product of product_variants_option.values
                                                            "
                                                        >
                                                            <span
                                                                [ngClass]="{
                                                                    'border-gray rounded-lg': environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                                    'unsellected-option-border': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                                    'active-option-select':
                                                                        product.state ==
                                                                        1
                                                                }"
                                                                class="unsellected-option"
                                                            >
                                                                <img
                                                                    (click)="
                                                                        selectVariant(
                                                                            product_variants_option.option,
                                                                            product,
                                                                            product_variant.id
                                                                        )
                                                                    "
                                                                    [ngClass]="
                                                                        product.active
                                                                            ? 'active-option-select'
                                                                            : ''
                                                                    "
                                                                    [src]="
                                                                        product.image
                                                                    "
                                                                    [alt]="
                                                                        product.name
                                                                    "
                                                                    class="option-img-varants"
                                                                    default="./assets/images/placeholder70.png"
                                                                    onError="this.src='./assets/images/placeholder70.png';"
                                                                />
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <div
                                                        *ngIf="
                                                            product_variants_option
                                                                .option.type ==
                                                                2 ||
                                                            product_variants_option
                                                                .option.type ==
                                                                4
                                                        "
                                                    >
                                                        <h6 class="name-option">
                                                            {{ 
                                                                lang == 'ar'? 
                                                                    product_variants_option.option.name_ar : product_variants_option.option.name
                                                            }}
                                                            <ng-container
                                                                *ngIf="
                                                                    selected_color
                                                                "
                                                                >{{
                                                                    " : " +
                                                                        selected_color
                                                                }}</ng-container
                                                            >
                                                        </h6>
                                                        <span
                                                            *ngFor="
                                                                let variant of product_variants_option.values
                                                            "
                                                        >
                                                            <span
                                                                [ngClass]="{
                                                                    'border-gray rounded-lg': environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                                    'unsellected-option-border': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI,
                                                                    'active-option-select':
                                                                        variant.state ==
                                                                        1
                                                                }"
                                                                class="unsellected-option"
                                                            >
                                                                <img
                                                                    (click)="
                                                                        selectVariant(
                                                                            product_variants_option.option,
                                                                            variant,
                                                                            product_variant.id
                                                                        )
                                                                    "
                                                                    [ngClass]="
                                                                        variant.active
                                                                            ? 'active-option-select'
                                                                            : ''
                                                                    "
                                                                    [src]="
                                                                        variant.image
                                                                    "
                                                                    [alt]="
                                                                        variant?.name
                                                                    "
                                                                    class="option-img-varants"
                                                                    default="./assets/images/placeholder70.png"
                                                                    onError="this.src='./assets/images/placeholder70.png';"
                                                                />
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div
                                                    *ngIf="
                                                        environmentVariables?.ENABLE_SHOW_SIZE_CHART &&
                                                        ((detailData
                                                            ?.downloadable
                                                            ?.downloadable_label &&
                                                            detailData
                                                                ?.downloadable
                                                                ?.downloadable_url) ||
                                                            (detailData
                                                                ?.downloadable
                                                                ?.downloadable_label_ar &&
                                                                detailData
                                                                    ?.downloadable
                                                                    ?.downloadable_url_ar))
                                                    "
                                                >
                                                    <button
                                                        mat-raised-button
                                                        color="accent"
                                                        class="button-lg mr-3 button-size-chart zoom"
                                                        (click)="
                                                            openDialogSizeChart()
                                                        "
                                                    >
                                                        {{
                                                            lang == "en"
                                                                ? detailData
                                                                      ?.downloadable
                                                                      ?.downloadable_label ||
                                                                  detailData
                                                                      ?.downloadable
                                                                      ?.downloadable_label_ar
                                                                : detailData
                                                                      ?.downloadable
                                                                      ?.downloadable_label_ar ||
                                                                  detailData
                                                                      ?.downloadable
                                                                      ?.downloadable_label
                                                        }}
                                                    </button>
                                                </div>

                                                <!-- Call To Action Btns -->
                                                <div
                                                    [ngClass]="{ 
                                                        'lang-ar': lang == 'ar',
                                                        'w-100': environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎',
                                                        'justify-end': (environmentVariables?.ENABLE_SHOW_BUY_NOW_BUTTON &&
                                                            environmentVariables?.GUEST_CAN_VIEW_PRICES &&
                                                            product_variant?.in_stock &&
                                                            !product_variant?.available_soon)
                                                    }"
                                                    class="d-flex flex-row align-items-center box-size-chart"
                                                >
                                                    <!-- favorite -->
                                                    <div
                                                        class="d-inline-flex mr-2"
                                                        *ngIf="!environmentVariables?.NEW_PRODUCTS_DETAILS_UI"
                                                    >
                                                        <button
                                                            class="compare_button"
                                                            (click)="
                                                                addToFavouriteList(
                                                                    product_variant
                                                                )
                                                            "
                                                            [disabled]="
                                                                toggleFavLoading
                                                            "
                                                            [style.cursor]="
                                                                toggleFavLoading
                                                                    ? 'not-allowed'
                                                                    : 'pointer'
                                                            "
                                                        >
                                                            <mat-icon
                                                                class="material-icons favorite"
                                                                [class.wishlist-active]="
                                                                    product_variant?.is_favourite
                                                                "
                                                            >
                                                                favorite
                                                            </mat-icon>
                                                            <div
                                                                class="loader-container"
                                                                *ngIf="toggleFavLoading"
                                                            >
                                                                <app-loading></app-loading>
                                                            </div>
                                                        </button>
                                                    </div>

                                                    <!-- compare -->
                                                    <div
                                                        class="d-inline-flex mr-2"
                                                        *ngIf="!environmentVariables?.NEW_PRODUCTS_DETAILS_UI"
                                                    >
                                                        <button
                                                            *ngIf="
                                                                !environmentVariables?.DISABLE_COMPARE
                                                            "
                                                            class="compare_button"
                                                            (click)="
                                                                addToCompareList(
                                                                    product_variant
                                                                )
                                                            "
                                                            [disabled]="
                                                                toggleCompareLoading
                                                            "
                                                            [style.cursor]="
                                                                toggleCompareLoading
                                                                    ? 'not-allowed'
                                                                    : 'pointer'
                                                            "
                                                        >
                                                            <mat-icon
                                                                class="material-icons favorite"
                                                                [class.wishlist-active]="
                                                                    product_variant?.is_compare
                                                                "
                                                            >
                                                                compare
                                                            </mat-icon>
                                                            <div
                                                                class="loader-container"
                                                                *ngIf="
                                                                    toggleCompareLoading
                                                                "
                                                            >
                                                                <app-loading></app-loading>
                                                            </div>
                                                        </button>
                                                    </div>

                                                    <!-- add to cart -->
                                                    <div
                                                        class="d-flex align-center"
                                                        [ngClass]="{
                                                            'pr-3': product_variant?.in_stock &&
                                                                environmentVariables?.ENABLE_SHOW_BUY_NOW_BUTTON,
                                                            'w-50': product_variant?.in_stock,
                                                            'w-100': !product_variant?.in_stock && 
                                                                !environmentVariables?.ENABLE_SHOW_BUY_NOW_BUTTON
                                                        }"
                                                        *ngIf="environmentVariables?.GUEST_CAN_VIEW_PRICES"
                                                    >
                                                        <!--Regular Product-->
                                                        <app-control-add-to-cart
                                                            [source]="'details'"
                                                            *ngIf="product_variant"
                                                            [product]="product_variant"
                                                            [styleCard]="true"
                                                            [styleDetails]="true"
                                                            [redirectToProduct]="false"
                                                            class="w-100"
                                                        >
                                                        </app-control-add-to-cart>
                                                    </div>

													<!-- buy now -->
													<div 
                                                        *ngIf="
                                                            environmentVariables?.ENABLE_SHOW_BUY_NOW_BUTTON &&
                                                            environmentVariables?.GUEST_CAN_VIEW_PRICES &&
                                                            product_variant?.in_stock &&
                                                            !product_variant?.available_soon
                                                        "
                                                        [ngClass]="{
                                                            'mx-2': environmentVariables?.ADD_TO_CART_TEXT_EN != '‎ +‎ ‎',
                                                            'w-50': environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'
                                                        }"
                                                    >
														<button
															mat-raised-button
															(click)="addToCart()"
                                                            [ngClass]="{
                                                                'w-150px px-2': environmentVariables?.ADD_TO_CART_TEXT_EN != '‎ +‎ ‎',
                                                                'w-100 h-40px': environmentVariables?.ADD_TO_CART_TEXT_EN == '‎ +‎ ‎'
                                                            }"
                                                            class="buy-now-btn no-shadow fs-24 lh1"
														>
                                                            <span class="d-flex justify-center align-items-center">
                                                                <mat-icon class="material-icons material-symbols-outlined" aria-hidden="false">
                                                                    shopping_cart
                                                                </mat-icon>
                                                                <span class="ml-1 text-capitalize">{{ "cart.Buy_NOW" | translate }}</span>
                                                            </span>
														</button>
													</div>

                                                    <!-- share desktop -->
                                                    <div
                                                        class="share-area share-web-view"
                                                        *ngIf="!environmentVariables?.NEW_PRODUCTS_DETAILS_UI"
                                                    >
                                                        <div class="divider"></div>

                                                        <div
                                                            class="row space-between center"
                                                            class="text-muted"
                                                        >
                                                            <button
                                                                mat-icon-button
                                                                (click)="
                                                                    openDialogShare()
                                                                "
                                                            >
                                                                <mat-icon
                                                                    >share</mat-icon
                                                                >
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- stock -->
                                                <div class="d-flex"
                                                    *ngIf="
                                                        environmentVariables?.SHOW_ITEMS_LEFT_LABEL &&
                                                        product_variant?.stock -
                                                            product_variant?.amount <
                                                            5 &&
                                                        product_variant?.stock -
                                                            product_variant?.amount >
                                                            0
                                                    ">
                                                    <p class="ma mt-0 mx-2" >
                                                        {{ "only" | translate }}

                                                        {{
                                                            product_variant.stock -
                                                                product_variant.amount
                                                        }}
                                                        {{ "left_in_stock" | translate }}
                                                    </p>
                                                </div>
                                                
                                                <!-- share mobile -->
                                                <div
                                                    *ngIf="!environmentVariables?.NEW_PRODUCTS_DETAILS_UI"
                                                    class="share-area share-mob-view row center text-muted py-2"
                                                >
													<button
														mat-icon-button
														(click)="openDialogShare()"
													>
														<mat-icon>
                                                            share
                                                        </mat-icon>
													</button>
                                                </div>

                                                <!-- Installment Banks -->
                                                <div class="mt-4" 
                                                    *ngIf="installment?.instalment_banks?.length && 
                                                    environmentVariables?.ENABLE_BANK_INSTALLMENTS_PRODUCT_UI">
                                                    <button 
                                                        type="button" 
                                                        (click)="navigateToPlanSection('#selected-installment-plan-info', false)"
                                                        class="
                                                            name-option 
                                                            text-capitalize 
                                                            border
                                                            bg-white
                                                            rounded-lg
                                                            d-flex
                                                            justify-center
                                                            align-items-center
                                                            p-2
                                                            shadow-sm
                                                            mb-3
                                                        ">
                                                        <span class="pl-2">
                                                            {{ 'productDetails.installmentPlans' | translate }}
                                                        </span>
                                                        <mat-icon>
                                                            {{ lang === 'ar' ? 'chevron_left' : 'chevron_right' }}
                                                        </mat-icon>
                                                    </button>

                                                    <!-- Banks -->
                                                    <div id="selected-installment-plan-info" class="d-none">
                                                        <div fxLayout="row wrap" class="col-sm-gap"
                                                            fxLayoutAlign="start center">
                                                            <ng-container *ngFor="let bank of installment.instalment_banks">
                                                                <div class="mb-3"
                                                                    (click)="selectBank(bank)"
                                                                    [matTooltip]="
                                                                        lang === 'ar' ? bank?.bank_name_ar : bank?.bank_name_en
                                                                    " >
                                                                    <img
                                                                        [src]="bank?.bank_image"
                                                                        class="object-fit-contain rounded-lg d-inline-block mb-1 rounded-lg shadow-sm border-3 border-brand-hover h-50px"
                                                                        [ngClass]="{
                                                                            'border-brand': 
                                                                                selectedBank?.bank_name_en === bank?.bank_name_en
                                                                        }"
                                                                        loading="lazy"
                                                                        width="95"
                                                                        height="50"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </ng-container>
                                                        </div>
    
                                                        <div class="name-option mt-0 text-capitalize" *ngIf="selectedBank">
                                                            {{ lang === 'ar' ? selectedBank.bank_name_ar : selectedBank.bank_name_en }}
                                                        </div>
    
                                                        <!-- Plans -->
                                                        <div fxLayout="row wrap" class="col-sm-gap" fxLayoutAlign="start center"
                                                            *ngIf="selectedInstallmentPlans?.length">
                                                            <div fxFlex.xl="15"
                                                                fxFlex.lg="17"
                                                                fxFlex.md="30"
                                                                fxFlex.sm="30"
                                                                fxFlex.xs="30"
                                                                class="mb-3 p-2 rounded-lg border-3 shadow-sm bg-white border-brand-hover text-center"
                                                                (click)="selectPlan(plan)"
                                                                [ngClass]="{
                                                                    'border-brand': selectedPlan.name_en === plan.name_en
                                                                }"
                                                                *ngFor="let plan of selectedInstallmentPlans">
                                                                <div class="text-brand">
                                                                    {{ lang === 'ar' ? plan.name_ar : plan.name_en }}
                                                                </div>
                                                            </div>
                                                        </div>
    
                                                        <!-- No Plans -->
                                                        <div class="mb-3" *ngIf="!selectedInstallmentPlans?.length">
                                                            No Plans Data
                                                        </div>
                                         
                                                        <div *ngIf="selectedPlan && selectedInstallmentPlans?.length">
                                                            <!-- Selected Installment Plan -->
                                                            <div>
                                                                <span class="text-brand fs-20">
                                                                    {{ selectedPlan?.amount_per_month }}
                                                                </span>
                                                                {{
                                                                    lang == "en"
                                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                                }} 
                                                                {{'productDetails.monthly' | translate}}
                                                                /
                                                                {{ selectedPlan.months }} 
                                                                {{ selectedPlan.months > 11 ? 
                                                                    ('productDetails.months' | translate) :
                                                                    ('productDetails.month' | translate)
                                                                }}
                                                            </div>
        
                                                            <!-- Installment Note -->
                                                            <div
                                                                class="text-capitalize text-dark mb-3 fs-12"
                                                                *ngIf="installment?.note_en"
                                                            >
                                                                {{
                                                                    lang == "ar"
                                                                        ? installment.note_ar
                                                                        : installment.note_en
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="w-100 border-bottom my-1"></div>
                                            </div>
                                        </li>

                                        <!-- description -->
                                        <li
                                            *ngIf="
                                                detailData?.details?.description
                                            "
                                        >
                                            <h4 class="accent-color price"
                                                [ngClass]="{
                                                    'fs-24 fw-bold text-capitalize pb-2': environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                                }"
                                            >
                                                {{
                                                    "productDetails.description" | translate
                                                }}
                                            </h4>
                                            <div class="py-1 lh flex">
                                                <p>
                                                    <span
                                                        [innerHTML]="
                                                            detailData?.description
                                                        "
                                                        class="fw-500 description-inner-html"
                                                    ></span>
                                                </p>
                                            </div>
                                        </li>
                                    </ul>

                                    <div class="bullets-points">
                                        <ul class="bullets-list">
                                            <li
                                                *ngFor="
                                                    let feature of detailData?.features
                                                "
                                            >
                                                {{ feature }}
                                            </li>
                                        </ul>
                                    </div>

                                    <div id="btnAddToCart"></div>
                                </div>
                            </div>

                            <!-- tab navigator -->
                            <div class="tabs-container">
                                <div
                                    *ngIf="
                                        detailData.long_description ||
                                        product_variant?.youtube_trusted_url ||
                                        product_variant?.details_banners?.length ||
                                        product_variant?.details_cards?.length ||
                                        product_variant?.custom_specs?.length
                                    "
                                    (click)="showTabContent('tab1')"
                                    [ngClass]="{
                                        'text-brand bg-white': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI && activeTab === 'tab1',
                                        'text-white bg-brand': environmentVariables?.NEW_PRODUCTS_DETAILS_UI && activeTab === 'tab1'
                                    }"
                                    class="tab-item"
                                >
                                    {{
                                        "productDetails.long_description" | translate
                                    }}
                                </div>
                                <div
                                    id="specification"
                                    *ngIf="
                                        detailData?.details?.attributes
                                            ?.length > 0
                                    "
                                    (click)="showTabContent('tab2')"
                                    [ngClass]="{
                                        'text-brand bg-white': !environmentVariables?.NEW_PRODUCTS_DETAILS_UI && activeTab === 'tab2',
                                        'text-white bg-brand': environmentVariables?.NEW_PRODUCTS_DETAILS_UI && activeTab === 'tab2'
                                    }"
                                    class="tab-item"
                                >
                                    {{
                                        "productDetails.specification" | translate
                                    }}
                                </div>
                            </div>

                            <!-- tab container -->
                            <div 
                                
                                [ngClass]="{
                                    'p-3 border-gray rounded-lg mx-md-3 w-100': 
                                        environmentVariables?.NEW_PRODUCTS_DETAILS_UI
                                }"
                                class="long-description"
                            >
                                <!-- tab 1 -->
                                <div class="w-100" *ngIf="
                                    activeTab === 'tab1'
                                ">
                                    <!-- long description -->
                                    <app-long-description [long_description]="detailData?.long_description"></app-long-description>
                                    <!-- <div 
                                        *ngIf="
                                            detailData?.long_description
                                        "
                                        class="description"
                                    >
                                        <div class="py-1 lh flex">
                                            <p>
                                                <span
                                                
                                                    [innerHTML]="
                                                        transform(
                                                            detailData?.long_description
                                                        )
                                                    "
                                                    class="details-font shop-details"
                                                ></span>
                                            </p>
                                        </div>
                                    </div> -->
                                
                                    <!-- description section -->
                                    <div
                                        class="w-100"
                                        *ngIf="product_variant"
                                    >
                                        <!-- youtube video -->
                                        <div
                                            class="py-3"
                                            *ngIf="product_variant.youtube_trusted_url"
                                        >
                                            <iframe
                                                [src]="product_variant.youtube_trusted_url"
                                                height="400px"
                                                width="100%"
                                                title="YouTube video player"
                                                frameborder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowfullscreen
                                            ></iframe>
                                        </div> 

                                        <!-- product banners -->
                                        <ng-container
                                            *ngIf="
                                                product_variant.details_banners &&
                                                product_variant.details_banners.length > 0
                                            "
                                        >
                                            <div
                                                class="py-3"
                                                *ngFor="
                                                    let banner of product_variant
                                                        .details_banners;
                                                    let i = index
                                                "
                                            >
                                                <img
                                                    [src]="
                                                        lang === 'en'
                                                            ? banner.image_en
                                                            : banner.image_ar
                                                    "
                                                    width="2200"
                                                    height="880"
                                                    [alt]="'banner ' + banner.id"
                                                    class="w-100 d-inline-block object-fit-cover"
                                                />
                                            </div>
                                        </ng-container>

                                        <div fxLayout="flex" fxLayoutAlign="center">
                                            <div fxFlex.gt-md="75">
                                                <!-- product cards -->
                                                <div
                                                    class="row-margin mt-2 mb-3"
                                                    fxLayout="row wrap"
                                                    *ngIf="
                                                        product_variant.details_cards &&
                                                        product_variant.details_cards.length > 0
                                                    "
                                                >
                                                    <div
                                                        class="p-3"
                                                        *ngFor="
                                                            let card of product_variant.details_cards
                                                        "
                                                        fxFlex.lg="25"
                                                        fxFlex.md="25"
                                                        fxFlex.sm="50"
                                                        fxFlex.xs="50"
                                                    >
                                                        <div class="mb-3">
                                                            <img
                                                                [src]="
                                                                    lang === 'en'
                                                                        ? card.image_en
                                                                        : card.image_ar
                                                                "
                                                                width="220"
                                                                height="220"
                                                                [alt]="'card ' + card.id"
                                                                class="w-100 d-inline-block object-fit-cover"
                                                            />
                                                        </div>
                                                        <div class="defult-price-color mb-2">
                                                            {{
                                                                lang === "en"
                                                                    ? card.title_en
                                                                    : card.title_ar
                                                            }}
                                                        </div>
                                                        <p class="mb-0 text-md">
                                                            {{
                                                                lang === "en"
                                                                    ? card.description_en
                                                                    : card.description_ar
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <!-- Product Specs -->
                                                <ng-container *ngIf="product_variant.custom_specs &&
                                                    product_variant.custom_specs.length > 0">
                                                    <!-- Title -->
                                                    <h1 class="fs-32 text-center mb-3">
                                                        {{ 'product_technical_specifications' | translate }}
                                                    </h1>
                                                    
                                                    <!-- Specs List -->
                                                    <div
                                                        class="row-margin"
                                                        fxLayout="row wrap"
                                                    >
                                                        <div
                                                            class="p-3"
                                                            fxFlex.lg="50"
                                                            fxFlex.md="50"
                                                            fxFlex.sm="100"
                                                            fxFlex.xs="100"
                                                        >
                                                            <table class="table table-striped">
                                                                <tbody>
                                                                    <tr
                                                                        *ngFor="
                                                                            let spec1 of product_variant
                                                                                .custom_specs1
                                                                        "
                                                                    >
                                                                        <td 
                                                                            width="50%"
                                                                            class="defult-price-color"
                                                                        >
                                                                            {{
                                                                                lang === "en"
                                                                                    ? spec1.title_en
                                                                                    : spec1.title_ar
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                lang === "en"
                                                                                    ? spec1.description_en
                                                                                    : spec1.description_ar
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
        
                                                        <div
                                                            class="p-3"
                                                            fxFlex.lg="50"
                                                            fxFlex.md="50"
                                                            fxFlex.sm="100"
                                                            fxFlex.xs="100"
                                                        >
                                                            <table class="table table-striped">
                                                                <tbody>
                                                                    <tr
                                                                        *ngFor="
                                                                            let spec2 of product_variant
                                                                                .custom_specs2
                                                                        "
                                                                    >
                                                                        <td 
                                                                            width="50%"
                                                                            class="defult-price-color"
                                                                        >
                                                                            {{
                                                                                lang === "en"
                                                                                    ? spec2.title_en
                                                                                    : spec2.title_ar
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                lang === "en"
                                                                                    ? spec2.description_en
                                                                                    : spec2.description_ar
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- tab 2 -->
                                <div
                                    *ngIf="
                                        detailData?.details?.attributes?.length &&
                                        activeTab === 'tab2'
                                    "
                                    class="specification bg-white"
                                >
                                    <div
                                        *ngFor="
                                            let optins of detailData?.details
                                                ?.attributes
                                        "
                                        class="py-1 lh d-flex flex-row justify-center align-items-stretch border-full"
                                    >
                                        <div class="title details-font px-2">
                                            {{ optins.option }}
                                        </div>
                                        <div class="value border-left px-2">
                                            <span
                                                [innerHTML]="optins?.value"
                                                [ngClass]="
                                                    lang == 'ar'
                                                        ? 'text-right'
                                                        : 'text-left'
                                                "
                                                class="details-font"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- <div class="py-5 rate-container w-100 d-flex justify-space-between" 
                               *ngIf="!environmentVariables?.ENABLE_PRODUCT_RATE">
                               
                                   <div class="left-section"
                                   fxFlex.xs="100"
                                   fxFlex.sm="100"
                                   fxFlex.md="33.33"
                                   fxFlex.lg="33.33"
                                   fxFlex.xl="33.33"
                                   >
                                     <div class="stars-container w-100"  style="
                                         display: flex;
                                         flex-direction: column;
                                         ">
                                         <p class="font-weight-bold fs-20">{{'orders.rating' | translate}}</p>
                                         <div class="d-flex  align-items-center">
                                             <div [ngStyle]="{
                                                 'width': lang === 'en' ? '15%' : (lang === 'ar' ? '15%' : 'auto')
                                               }" class="star-item" >5 {{'orders.Stars' | translate}}</div> 
                                             <mat-progress-bar 
                                                  mode="determinate" 
                                                  color="primary"
                                                  [value]="product_variant?.rate_details?.count_5"
                                                  >
                                              </mat-progress-bar>
                                               <div  >{{product_variant?.rate_details?.count_5}}</div>
                                         </div>
                                         <div class="d-flex  align-items-center">
                                             <div [ngStyle]="{
                                                 'width': lang === 'en' ? '15%' : (lang === 'ar' ? '15%' : 'auto')
                                               }" class="star-item">4 {{'orders.Stars' | translate}}</div> 
                                             <mat-progress-bar 
                                                  mode="determinate" 
                                                  color="primary"
                                                  [value]="product_variant?.rate_details?.count_4"
                                                  >
                                              </mat-progress-bar>
                                               <div  >{{product_variant?.rate_details?.count_4}}</div>
                                         </div>
                                         <div class="d-flex align-items-center">
                                             <div [ngStyle]="{
                                                 'width': lang === 'en' ? '15%' : (lang === 'ar' ? '15%' : 'auto')
                                               }" class="star-item">3 {{'orders.Stars' | translate}}</div> 
                                             <mat-progress-bar 
                                                  mode="determinate" 
                                                  color="primary"
                                                  [value]="product_variant?.rate_details?.count_3"
                                                  >
                                              </mat-progress-bar>
                                               <div  >{{product_variant?.rate_details?.count_3}}</div>
                                         </div>
                                         <div class="d-flex  align-items-center">
                                             <div [ngStyle]="{
                                                 'width': lang === 'en' ? '15%' : (lang === 'ar' ? '15%' : 'auto')
                                               }" class="star-item">
                                                 <span>2</span>
                                                 {{'orders.star' | translate}}</div> 
                                             <mat-progress-bar 
                                                  mode="determinate" 
                                                  color="primary"
                                                  [value]="product_variant?.rate_details?.count_2"
                                                  >
                                              </mat-progress-bar>
                                               <div  >{{product_variant?.rate_details?.count_2}}</div>
                                         </div>
                                         <div class="d-flex  align-items-center">
                                             <div 
                                             [ngStyle]="{
                                                 'width': lang === 'en' ? '15%' : (lang === 'ar' ? '15%' : 'auto')
                                               }"
                                               class="star-item">
                                                 <span>1</span>
                                                 {{'orders.oneStar' | translate}}</div> 
                                             <mat-progress-bar 
                                                  mode="determinate" 
                                                  color="primary"
                                                  [value]="product_variant?.rate_details?.count_1"
                                                  >
                                              </mat-progress-bar>
                                               <div  >{{product_variant?.rate_details?.count_1}}</div>
                                         </div>
                                     </div>
                                  
                               
                                   
                                   </div>

                                   <div class="medile-section"
                                   fxFlex.xs="100"
                                   fxFlex.sm="100"
                                   fxFlex.md="33.33"
                                   fxFlex.lg="33.33"
                                   fxFlex.xl="33.33"
                                   >
                                    <div class="overall-rating-container">
                                        <div class="font-weight-bold fs-20">
                                            {{'orders.overallRating' | translate
                                        }}
                                        </div>
                                        <div class="overall-rating" >
    
                                            <p class="fs-40 mb-0">
                                               {{product_variant?.rate_details?.rate?.toFixed(1)}}</p>

                                            <div class="text-center" style="margin-top: -12px;">

                                               <bar-rating
                                               class="mx-2"
                                               style="color: goldenrod;line-height: 15px;"
                                               [rate]="product_variant?.rate_details?.rate"
                                               [max]="5"
                                               [readOnly]="true"
                                             ></bar-rating>
                                               <span 
                                               [ngStyle]="{
                                                   'left': lang === 'en' ? '-29px' : (lang === 'ar' ? 'auto' : 'auto'),
                                                   'right': lang === 'ar' ? '-29px' : (lang === 'en' ? 'auto' : 'auto')
                                                 }"

                                               style="
                                                           position: relative;
                                                           top: -50px;
                                                           font-weight: bolder;
                                                           font-size: 20px !important;
                                                           width: 119px;
                                                           display: block;
                                               ">
                                              <span>{{product_variant?.rate_details?.count}}</span> 
                                               <span class="mx-1"> {{'orders.rate' | translate}}</span> 
                                               </span>
                                            </div>
                                       
                                        </div>
                                    </div>
                                   </div>
 
                                   <div class="rigth-section"
                                   fxFlex.xs="100"
                                   fxFlex.sm="100"
                                   fxFlex.md="33.33"
                                   fxFlex.lg="33.33"
                                   fxFlex.xl="33.33"
                                   >
                                    <div>
                                            <p  class="text-left font-weight-bold fs-20">{{'orders.rateThisProduct' | translate}}</p>
                                                <bar-rating
                                                class="custom-rating"
                                                style="color: goldenrod;line-height: 45px;"
                                                [rate]="product_variant?.rate_details?.user_rate"
                                                [max]="5"
                                                (rateChange)="rateProduct($event)"
                                                [readOnly]="isRateLoading"
                                            >
                                        
                                                  </bar-rating>
                                                    <div
                                                        *ngIf="isRateLoading"
                                                        class="loader-rate">
                                                        <app-loading></app-loading>
                                                    </div>
                                    </div>
                                   
                                 
                           
                                
                                   </div>
                             
                             </div> -->



                             <ng-container *ngIf="environmentVariables?.ENABLE_PRODUCT_RATE">
                          <div class="d-flex py-5 rate-container w-100">
                            <div 
                            fxFlex.xs="100"
                            fxFlex.sm="100"
                            fxFlex.md="33.33"
                            fxFlex.lg="33.33"
                            fxFlex.xl="33.33"
                            >
                            <p class="font-weight-bold fs-20">{{'orders.rating' | translate}}</p>
                           
                            <div *ngIf="product_variant?.rate_details">
                                <div class="d-flex align-items-center" *ngFor="let star of [5, 4, 3, 2, 1]">
                                    <div [ngStyle]="{
                                        'width': lang === 'en' ? '15%' : (lang === 'ar' ? '15%' : 'auto')
                                      }" class="star-item">{{star}} {{'orders.Stars' | translate}}</div> 
                                    <mat-progress-bar 
                                        mode="determinate" 
                                        color="primary"
                                        [value]="calculatePercentage(product_variant?.rate_details['count_' + star], product_variant?.rate_details?.count)"
                                    ></mat-progress-bar>
                                    <div>{{product_variant?.rate_details['count_' + star]}}</div>
                                </div>
                            </div>
                            

                            </div>
                            <div 
                            fxFlex.xs="100"
                            fxFlex.sm="100"
                            fxFlex.md="33.33"
                            fxFlex.lg="33.33"
                            fxFlex.xl="33.33"
                            >
                            <p class="font-weight-bold fs-20 overall-rating-text ">
                               {{'orders.overallRating' | translate}}
                           </p>
                           <div class="overall-rating mt-1 d-flex" >
   
                               <p class="fs-40 mb-0">
                                  {{product_variant?.rate_details?.rate?.toFixed(1)}}</p>

                               <div class="text-center rate-numbers-container" >

                                  <bar-rating
                                  class="mx-2"
                                  style="color: goldenrod;line-height: 15px;"
                                  [rate]="product_variant?.rate_details?.rate"
                                  [max]="5"
                                  [readOnly]="true"
                                ></bar-rating>
                                  <span 
                                  [ngStyle]="{
                                      'left': lang === 'en' ? '-29px' : (lang === 'ar' ? 'auto' : 'auto'),
                                      'right': lang === 'ar' ? '-29px' : (lang === 'en' ? 'auto' : 'auto')
                                    }"

                                  style="
                                              position: relative;
                                              top: -50px;
                                              font-weight: bolder;
                                              font-size: 20px !important;
                                              width: 119px;
                                              display: block;
                                  ">
                                 <span>{{product_variant?.rate_details?.count}}</span> 
                                  <span class="mx-1"> {{'orders.rate' | translate}}</span> 
                                  </span>
                               </div>
                          
                           </div>
                            </div>
                            <div 
                            fxFlex.xs="100"
                            fxFlex.sm="100"
                            fxFlex.md="33.33"
                            fxFlex.lg="33.33"
                            fxFlex.xl="33.33"
                            >
                            <p  class="text-left font-weight-bold fs-20">{{'orders.rateThisProduct' | translate}}</p>

                            <bar-rating
                            class="custom-rating"
                            style="color: goldenrod;line-height: 45px;"
                            [rate]="product_variant?.rate_details?.user_rate"
                            [max]="5"
                            (rateChange)="rateProduct($event)"
                            [readOnly]="isRateLoading"
                        >
                    
                              </bar-rating>
                                <div
                                    *ngIf="isRateLoading"
                                    class="loader-rate">
                                    <app-loading></app-loading>
                                </div>
                            </div>
                          </div>
                             
                             </ng-container>
                            

                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
